// extracted by mini-css-extract-plugin
export default {"root":"style_root__1HVkf","deckList":"style_deckList__xK5mJ","deckItem":"style_deckItem__h88QB","selected":"style_selected__0D-ER","footer":"style_footer__73sKE"};